import '../../../../../node_modules/react-datepicker/dist/react-datepicker.css'

import DatePicker from 'react-datepicker'

import styles from './Datepicker.module.scss'

const Datepicker = props => {
  return (
    <div
      className={[styles.datepicker, props.className ? props.className : ''].join(' ')}
    >
      <div className={styles.label}>
        {props.label && <div className={styles.labelInner}>{props.label}</div>}
        <DatePicker {...props} />
      </div>
    </div>
  )
}

export default Datepicker
